import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractPorchPatioDeck(sale: Element): string | undefined {
  return extractAdjustmentDescription(sale, 'PorchDeck');
}
